// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `fdx-info-modal span{overflow-wrap:break-word}`, "",{"version":3,"sources":["webpack://./public_html/modules/modal/components/fdx-info-modal/fdx-info-modal.styles.scss"],"names":[],"mappings":"AAAA,oBACC,wBAAA","sourcesContent":["fdx-info-modal span {\n\toverflow-wrap: break-word;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
